import State from './state'
import { MANIFEST_PATH, asset } from './config'

async function load() {
  try {
    const res = await fetch(asset(MANIFEST_PATH), { cache: 'force-cache' })
    if (!res.ok) throw new Error(String(res.status))
    const json = await res.json()
    const fg = Array.isArray(json.foregroundDays) ? json.foregroundDays : []
    State.foregroundDays = new Set<number>(fg.map((n: unknown) => Number(n)))
  } catch {
    State.foregroundDays = new Set()
  } finally {
    State.manifestLoaded = true
  }
}

function hasForeground(d: number) {
  return State.manifestLoaded && State.foregroundDays.has(d)
}

export default { load, hasForeground }
